<template>
<div class="sezione assicurazione"  style="padding-top:20px;">


  <div class="row row-head" >
    <div class="col s5 yo-align-left white">POLIZZA SOTTOSCRITTA</div>
    <div class="col s2 yo-align-center white">GIORNO</div>
    <div class="col s2 yo-align-center white">IMPORTO</div>
    <div class="col s3 yo-align-center white">MEZZO</div>
  </div>

  
  <div  class="row row-table" v-for="(itm, index) in dbData" v-bind:key="index">
    <div class="col s5">{{itm.qtsigla}}</div>
    <div class="col s2 yo-align-center">{{itm.vrsdata | data('DD-MM-YYYY')}}</div>
    <div class="col s2 yo-align-center">{{itm.qtimporto | money('€ ')}}</div>
    <div class="col s3 yo-align-center">{{itm.vrsmezzo}}</div>
  </div>

   
</div>
</template>

<script>

export default {
  components: {
  },
  created () {
  },
  data () {
    return {       
    }
  },
  computed:{
    dbData:function(){
        var filterData = []
        if(this.$socio._assicurazione.length>0)
        for(let item of this.$socio._assicurazione){
            filterData.push(item)    
        }  
        return filterData //.sort(this.$teras.compareValues('cognome',this.order)); 
    }
   },
   methods:{  
  }
}
</script>